
export class RemidoWebModel {

    constructor(
        public cdCentrus?: number,
        public dhRegistro?: Date,
        public irFiliacao?: string,
        public vl12UltContr?: number,
        public vlSaldoAtual?: number
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/remido-web.model.ts